import {Checkout} from '../../../types/checkoutApp.types';
import {mapNullToUndefined} from '../../utils/mapperHelper.utils';
import {CustomSettingsModel} from './CustomSettings.model';
import {CustomerInfoModel} from './CustomerInfo.model';
import {SiteInfoModel} from './SiteInfo.model';
import {SourceModel} from './Source.model';
import {PaymentInfoModel} from './PaymentInfo.model';

export class CartModel {
  public id: string;
  public purchaseFlowId: string;
  public updatedDate: string;
  /**
   * @deprecated
   */
  public cartId?: string;
  public customSettings?: CustomSettingsModel;
  public customerInfo: CustomerInfoModel;
  public siteInfo: SiteInfoModel;
  public source: SourceModel;
  public paymentInfo: PaymentInfoModel;
  public extendedFields?: {namespaces?: any};

  constructor(params: CartModel) {
    this.id = params.id;
    this.purchaseFlowId = params.purchaseFlowId;
    this.updatedDate = params.updatedDate;
    this.cartId = params.cartId;
    this.customSettings = params.customSettings;
    this.customerInfo = params.customerInfo;
    this.siteInfo = params.siteInfo;
    this.source = params.source;
    this.paymentInfo = params.paymentInfo;
    this.extendedFields = params.extendedFields;
  }

  public static fromCheckoutV1(checkout: Checkout): CartModel {
    return new CartModel({
      id: checkout.id!,
      purchaseFlowId: checkout.purchaseFlowId!,
      updatedDate: checkout.updatedDate!,
      cartId: mapNullToUndefined(checkout.cartId),
      customSettings: CustomSettingsModel.fromCheckoutV1(checkout.customSettings),
      customerInfo: CustomerInfoModel.fromCheckoutV1(checkout.buyerLanguage!, checkout.buyerInfo),
      siteInfo: SiteInfoModel.fromCheckoutV1(checkout.siteLanguage!),
      source: SourceModel.fromCheckoutV1(checkout.channelType),
      paymentInfo: PaymentInfoModel.fromCheckoutV1(checkout.paymentCurrency),
      extendedFields: mapNullToUndefined(checkout.extendedFields),
    });
  }
}
